import { VStack, HStack, Text, Box } from "@chakra-ui/react";
import React from "react";

export const FilterSummary = ({
  title,
  count,
  values,
}: {
  title: string;
  count: string;
  values: string[];
}) => {
  return (
    <VStack gap={2.5}>
      <HStack w="100%">
        <Text color="#718096" fontSize="14px" fontWeight={500}>
          {title}
        </Text>
        <Box
          bg="#666"
          borderRadius="20px"
          px={1.5}
          py={0.75}
          color="white"
          fontSize="12px"
        >
          {count}
        </Box>
      </HStack>
      <HStack gap={2.5} w="100%" flexWrap="wrap">
        {values.map((value) => (
          <Box
            key={value}
            bg="#EDF2F7"
            borderRadius="4px"
            px={1.5}
            color="rgba(0, 0, 0, 0.70)"
            fontWeight={500}
            fontSize="14px"
            lineHeight="23px"
          >
            {value}
          </Box>
        ))}
      </HStack>
    </VStack>
  );
};
